import {createAsyncThunk} from "@reduxjs/toolkit";
import type {User, UserRole} from "../../types";
import * as usersApi from "../../api/users.api";

export const fetchUsers = createAsyncThunk(
    'users/fetchUsers',
    async (
        { page = 0, size = 20, query, role }: {
            page?: number
            size?: number
            query?: string
            role?: UserRole
        },
        { rejectWithValue }
    ) => {
        try {
            return await usersApi.fetchUsers({ page, size, query, role })
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

export const searchUsers = createAsyncThunk(
    'users/searchUsers',
    async (query: string, { rejectWithValue }) => {
        try {
            return await usersApi.searchUsers(query)
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

export const searchPlayers = createAsyncThunk(
    'users/searchPlayers',
    async (query: string, { rejectWithValue }) => {
        try {
            return await usersApi.searchPlayers(query)
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

export const updateUser = createAsyncThunk(
    'users/updateUser',
    async (
        { userId, data }: { userId: number; data: Partial<User> },
        { rejectWithValue }
    ) => {
        try {
            await usersApi.updateUser(userId, data)
            return { userId, data }
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

export const createUser = createAsyncThunk(
    'users/createUser',
    async (
        data: {
            email?: string
            phone?: string
            fullName: string
            role?: UserRole
            birthDate?: string
            military?: boolean
            serviceTableId?: number | null
        },
        { rejectWithValue }
    ) => {
        try {
            return await usersApi.createUser(data)
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

export const deleteUser = createAsyncThunk(
    'users/deleteUser',
    async (userId: number, { rejectWithValue }) => {
        try {
            await usersApi.deleteUser(userId)
            return userId
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)